const getVehicleIcon = vehicle => {
  var iconColor = 'greencar'

  if (vehicle.color == 1) {
    iconColor = 'greencar'
  } else if (vehicle.color == 2) {
    iconColor = 'bluecar'
  } else if (vehicle.color == 4) {
    iconColor = 'yellowcar'
  } else {
    iconColor = 'redcar'
  }

  if (vehicle.poi) {
    iconColor = iconColor + 'animated'
  }

  let iconPixelCount = vehicle.pixelCount != null ? vehicle.pixelCount : 30;

  if (vehicle.isDataBuffering) {
    return window.L.divIcon({
      html: `
        <div 
          class="vehicle-container" 
          style="position: relative; width:${iconPixelCount + 10}px; height:${iconPixelCount + 10}px;">
          <div class="leaflet-loading-ring" 
               style="width:${iconPixelCount + 10}px; height:${iconPixelCount + 10}px;">
          </div>
          <img 
            src="${process.env.VUE_APP_S3_DOMAIN}/icons/${vehicle.icon}" 
            alt="vehicle"
            style="width:${iconPixelCount}px; height:${iconPixelCount}px; margin-top:-20px; margin-left:-20px;"
            class="${iconColor}"
          />
        </div>
      `,
      iconSize: [iconPixelCount, iconPixelCount],
      className: ''
    });
  }

  return window.L.icon({
    iconUrl: `${process.env.VUE_APP_S3_DOMAIN}/icons/${vehicle.icon}`,
    iconSize: [iconPixelCount, iconPixelCount],
    iconAnchor: [20, 20],
    className: iconColor
  })
}

export { getVehicleIcon }
